import { useMemo } from "react";
import { getSearchEntityTypesForUser } from "../../search/searchEntities";
import { useGlobalState } from "../../../GlobalContext";
import { useSavedViews } from "../../search/savedViews/useSavedViews";
import { SearchFilterBar } from "../../search/SearchFilterBar";
import { SearchMenu } from "../../search/SearchMenu";
import { SearchResults } from "../../search/SearchResults";
import { SearchSelectionBar } from "../../search/SearchSelectionBar";
import { useAdvancedSearch } from "../../search/useAdvancedSearch";

/** The advanced search page: pick what to search for, build the rules, act on the results. */
export function AdvancedSearchPanel() {
  const { user } = useGlobalState();
  const { allowedEntityTypes, searchTypeEnum } = getSearchEntityTypesForUser(user);
  const search = useAdvancedSearch({ initialEntity: "contact", allowedEntityTypes });
  const savedViews = useSavedViews({ search, allowedEntityTypes });

  const entityOptions = useMemo(
    () =>
      Object.entries(searchTypeEnum as Record<string, string>).map(([Value, Key]) => ({
        Key,
        Value,
      })),
    [searchTypeEnum]
  );

  return (
    <div className="page-section d-flex flex-column flex-grow-1 min-w-0 min-h-0">
      {savedViews.view && (
        <h2 className="h5 fw-semibold pt-2 mb-0">{savedViews.view.name}</h2>
      )}
      <SearchFilterBar
        search={search}
        allowedEntityTypes={allowedEntityTypes}
        entityOptions={entityOptions}
        onEntityChange={(entityName) => {
          search.setEntity(entityName);
          savedViews.clear();
        }}
        onClear={() => {
          search.reset();
          savedViews.clear();
        }}
      />
      <SearchSelectionBar search={search} alwaysShow>
        <SearchMenu
          toolbar
          showActions
          search={search}
          allowedEntityTypes={allowedEntityTypes}
          savedViews={savedViews}
        />
      </SearchSelectionBar>
      <SearchResults search={search} scrollable />
    </div>
  );
}
